import React from "react";
import styled from "styled-components";
import { PopupButton } from "react-calendly";

const GetInTouch = () => {
  return (
    <div id="contact-section">
      <CTASection>
        <CTATitle>Join Us On Our Journey</CTATitle>
        <CTADescription>
          Technology is constantly evolving, and so are we. Whether you’re a client, partner, or simply someone who shares our passion for innovation, we’d love to connect with you.
        </CTADescription>
        <CTAButton
          url="https://calendly.com/tech-rasynth"
          rootElement={document.getElementById("root")}
          text="Schedule a Call"
        />
      </CTASection>
    </div>
  );
};

export default GetInTouch;

// Styled Components
const CTASection = styled.section`
  text-align: center;
  padding: 3rem 1rem;
  background-color: #f8f9fa;
  border-radius: 10px;
  margin-top: 3rem;
`;

const CTATitle = styled.h3`
  font-size: 2rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
`;

const CTADescription = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
`;

// Styled Calendly Button
const CTAButton = styled(PopupButton)`
  background-color: #000;
  color: #fff;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #4a4a4a;
  }
`;
